import React, { useState } from "react";
import {
  ChevronDown,
  Brain,
  ArrowLeft,
  MessageCircle,
  Phone,
  Mail,
} from "lucide-react";
import Footer from '../components/Footer';
export default function FAQ() {
  const faqList = [
     {
        question: "What is JustOffPlan.ai?",
          answer: "JustOffPlan.ai is the UAE's first AI-powered platform specifically designed for off-plan property discovery. We connect buyers directly with developers, eliminating middlemen and commissions while providing intelligent property matching based on your preferences and budget."
        },
        {
          question: "How is this different from other property platforms?",
          answer: "Unlike traditional platforms, we use advanced AI to filter and rank properties based on your behavior, preferences, and budget. We focus exclusively on off-plan properties, provide real-time data synced with developers, and eliminate agent commissions entirely."
        },
     {
          question: "How can I get help if I have issues?",
          answer: "You can contact our support team through multiple channels: live chat on our platform, email support, or phone. We also have comprehensive help documentation and video tutorials."
        },
        {
          question: "Do you provide property investment advice?",
          answer: "While we provide comprehensive property information and market insights, we recommend consulting with qualified financial advisors for personalized investment advice. Our role is to facilitate connections and provide transparent information."
        },
        {
          question: "Is my personal information secure?",
          answer: "Yes, we take data security seriously. All personal information is encrypted and stored securely. We never share your contact details with third parties without your explicit consent."
        },
        {
         question: "Is this platform suitable for first-time buyers?",
          answer: "Absolutely! Our platform is designed to be user-friendly for first-time buyers. We provide comprehensive information, transparent pricing, and direct access to developers without the pressure often associated with traditional property agents."
        },
        {
          question: "Can international investors use this platform?",
          answer: "Yes, our platform is perfect for international investors looking to access the Dubai real estate market remotely. We provide detailed information, virtual tours, and direct developer communication to build trust and transparency."
        },
        {
          question: "What information do I get about each property?",
          answer: "For each property, you get detailed brochures, floor plans, payment schedules, developer information, project timelines, amenities, location details, and high-quality images or virtual tours."
        },
        {
        question: "What types of properties are available?",
          answer: "We focus exclusively on off-plan properties in the UAE, including apartments, villas, townhouses, and commercial properties from verified developers across Dubai, Abu Dhabi, Sharjah, and other emirates."
        },
        {
          question: "How can I filter properties?",
          answer: "You can filter by budget range, location, developer, property type, handover year, payment plan, amenities, and more. Our smart search also provides AI-powered suggestions based on your preferences."
        },
        {
          question: "Can I save my searches?",
          answer: "Yes, you can save your search criteria and receive instant notifications when new properties matching your preferences are launched. This ensures you never miss opportunities."
        },
       
 
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-gradient-to-br from-slate-50 to-white min-h-screen">
        <section className="pt-24 px-4 md:px-8 lg:px-12 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center bg-teal-100 text-teal-700 rounded-full px-4 py-2 mb-6">
          <MessageCircle className="w-4 h-4 mr-2" />
          <span className="text-sm font-medium">Frequently Asked Questions</span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
          Got Questions?
          <span className="block text-teal-600">We Have Answers</span>
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Find answers to common questions about JustOffPlan.ai, how it works,
          and how it can help you find your perfect off-plan property.
        </p>
      </section>
      <section className="py-24 px-4 md:px-8 lg:px-12 max-w-5xl mx-auto text-center">
     

        <div className="space-y-4 text-left max-w-3xl mx-auto">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-md overflow-hidden"
            >
              <button
                className="w-full px-4 py-3 font-medium text-gray-900 flex justify-between items-center"
                onClick={() => toggleAccordion(index)}
              >
                {faq.question}
                <span>{openIndex === index ? "-" : "+"}</span>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 text-sm text-gray-700">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
